export { IreRelatedEntities } from './IreRelatedEntities';
